import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import CaboCheckLogo from "~/assets/logos/logo.svg";

export function PublicFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200 bg-white/50">
      <div className="public-container flex-row flex-wrap items-center gap-5 py-7">
        <Link to="/" aria-label={t("CaboCheck Startseite")} className="flex items-center gap-3">
          <img src={CaboCheckLogo} alt="CaboCheck" className="h-7 w-auto" />
        </Link>
        <div className="flex-1" />
        <nav aria-label={t("Rechtliches")} className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-500">
          <Link to="/impressum" className="transition hover:text-slate-950">
            {t("Impressum")}
          </Link>
          <Link to="/datenschutz" className="transition hover:text-slate-950">
            {t("Datenschutzerklärung")}
          </Link>
          <Link to="/agb" className="transition hover:text-slate-950">
            {t("Allgemeine Geschäftsbedingungen")}
          </Link>
          <Link to="/register/pharmacy/step2" className="transition hover:text-slate-950">
            {t("Kontakt aufnehmen")}
          </Link>
        </nav>
        <p className="basis-full text-xs text-slate-500">
          © {year} Healyzer Health Analyzing Technologies GmbH · {t("Präventions-Diagnostik für Apotheken")}
        </p>
      </div>
    </footer>
  );
}
